import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import classNames from 'classnames';

import IsnIntegrationBox from '../../shared/IsnIntegration';
import { ISN_RESPONSE_STATUS } from '../../../constants/isnResponse';
import Button from '../../shared/Button';
import Checkbox from '../../shared/Checkbox';
import styles from './styles.scss';
import { toTimeString } from '../../../utils/dates';
import { QC_LAYOUT } from '../../../constants/reportLayouts';

class IsnPostReport extends React.Component {
  constructor(props) {
    super(props);
  }

  static get propTypes() {
    return {
      canEdit: PropTypes.bool,
      test: PropTypes.object,
      onFieldChange: PropTypes.func,
      onIsnPostData: PropTypes.func,
      isnDataPosting: PropTypes.bool,
      isnDataPostedResult: PropTypes.object,
      tzAbbr: PropTypes.string,
      hasData: PropTypes.bool,
      isTestCompleted: PropTypes.bool,
      layout: PropTypes.string,
      company: PropTypes.object,
      disabled: PropTypes.bool,
    };
  }

  checkIsnDataPost() {
    const { isnDataPostedResult } = this.props;
    return isnDataPostedResult && isnDataPostedResult.status === ISN_RESPONSE_STATUS.OK;
  }

  render() {
    const {
      canEdit,
      test,
      onFieldChange,
      onIsnPostData,
      isnDataPosting,
      isnDataPostedResult,
      tzAbbr,
      hasData,
      isTestCompleted,
      layout,
      company,
      disabled,
    } = this.props;

    const sideContent = (
      <Col md={12}>
        <div className={styles.isnCheckbox}>
          <Checkbox
            disabled={true}
            checked={test.isIsn}
            onChange={(value) => {
              canEdit ? onFieldChange('isIsn', value) : {};
            }}
          />
          <span
            onClick={() => {
              canEdit ? onFieldChange('isIsn', !test.isIsn) : {};
            }}
            className={classNames(styles.disabled, 'font-weight-bold')}
          >
            Sync Test with ISN
          </span>
        </div>
        <div className={styles.info}>
          Fields with green labels are pulling data from Order in ISN. Click on the{' '}
          <b className={styles.bold}>Post Report to ISN</b> button below to post a copy of the official radon report for
          this test as an Attachment for this Order in ISN.
        </div>
      </Col>
    );

    const isIsnDataPostedSuccessfull = this.checkIsnDataPost();
    const postDisabled =
      disabled ||
      !test.isIsn ||
      (test.company && !test.company.isIsn) ||
      (company && company.isIsn) ||
      !hasData ||
      !isTestCompleted;

    return (
      <IsnIntegrationBox sideContent={sideContent}>
        <Col md={12} className={styles.isnData}>
          <div className={styles.label}>
            ISN Test ID<div className={styles.value}>{test.isnTestDisplayOid}</div>
          </div>
          <div className={styles.footer}>
            <Button
              className={styles.postButton}
              disabled={isnDataPosting || postDisabled}
              key="save"
              kind={!postDisabled ? 'green' : 'gray'}
              onClick={!postDisabled ? onIsnPostData : () => {}}
            >
              {isnDataPosting ? <i className="fa fa-spin fa-spinner" /> : 'Post Report to ISN'}
            </Button>
            <Choose>
              <When condition={isnDataPostedResult}>
                <div className={isIsnDataPostedSuccessfull ? styles.ok : styles.fail}>
                  {`${isnDataPostedResult && isnDataPostedResult.message ? isnDataPostedResult.message : ''} 
                  ${isIsnDataPostedSuccessfull ? toTimeString(isnDataPostedResult.isnAttachmentDate, tzAbbr) : ''}`}
                </div>
              </When>
              <Otherwise>
                <If condition={test.isnAttachmentId}>
                  <div className={styles.ok}>
                    {`The report has been successfully posted to ISN at ${toTimeString(
                      test.isnAttachmentDate,
                      tzAbbr,
                    )}`}{' '}
                  </div>
                </If>
              </Otherwise>
            </Choose>
          </div>
        </Col>
      </IsnIntegrationBox>
    );
  }
}
export default IsnPostReport;



// WEBPACK FOOTER //
// src/components/testDetails/IsnPostReport/index.jsx